import React from 'react';

import { Typography } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import Box from '@material-ui/core/Box';
import DynamicForm from '../../components/dynamicForm/DynamicForm';
import { useHistory } from 'react-router-dom';
import NavLink from '../../components/displayValues/NavLink';

const fields = [
  {
    name: 'email',
    label: 'Email',
    fieldType: 'text',
    inputType: 'email',
    errorMessage: 'Please enter your email',
  },
];

function ForgotPassword() {
  const history = useHistory();
  const handleForgotPasswordClick = async (data) => {
    try {
      await Auth.forgotPassword(data.email).then((response) => {
        history.push('/auth/reset-password', {
          email: data.email,
        });
      });
    } catch (error) {
      console.log('error resetting password', error);
    }
  };

  return (
    <React.Fragment>
      <Typography variant="h6" align="center" gutterBottom color={'primary'}>
        Forgot your password?
      </Typography>
      <Box mb={5}>
        <Typography align="center" gutterBottom color="textSecondary">
          Enter your email below and we will send a message to reset your
          password
        </Typography>
      </Box>
      <Box my={10} />
      <Box my={5}>
        <DynamicForm
          fields={fields}
          formSubmitCallback={handleForgotPasswordClick}
          formOptions={{ submitButtonLabel: 'Reset Password' }}
        />
      </Box>
      <Box>
        <Typography component="h2" variant="body1" align="center" gutterBottom>
          Remember your password?&nbsp;
          <NavLink href="/auth/sign-in" text="Sign In" />
        </Typography>
      </Box>
    </React.Fragment>
  );
}

export default ForgotPassword;
